module.exports = __webpack_public_path__ + "media/components/country-flag/static/as-d510ae07930f4d6d3613d80d72fd84f8.svg";